import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { SearchkitComponent, FastClick, renderComponent } from "../../../../core";

var defaults = require("lodash/defaults");

var size = require("lodash/size");

var map = require("lodash/map");

export var FilterItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(FilterItem, _React$PureComponent);

  function FilterItem() {
    _classCallCheck(this, FilterItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(FilterItem).apply(this, arguments));
  }

  _createClass(FilterItem, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return React.createElement("div", {
        className: props.bemBlocks.option().mix(props.bemBlocks.container("item")).mix("selected-filter--".concat(props.filterId))
      }, React.createElement("div", {
        className: props.bemBlocks.option("name")
      }, props.labelKey, ": ", props.labelValue), React.createElement(FastClick, {
        handler: props.removeFilter
      }, React.createElement("div", {
        className: props.bemBlocks.option("remove-action")
      }, "x")));
    }
  }]);

  return FilterItem;
}(React.PureComponent);
export var SelectedFilters =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(SelectedFilters, _SearchkitComponent);

  function SelectedFilters(props) {
    var _this;

    _classCallCheck(this, SelectedFilters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectedFilters).call(this, props));
    _this.translate = _this.translate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SelectedFilters, [{
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      var blockName = this.props.mod || "sk-selected-filters";
      return {
        container: blockName,
        option: "".concat(blockName, "-option")
      };
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.getQuery().getSelectedFilters();
    }
  }, {
    key: "hasFilters",
    value: function hasFilters() {
      return size(this.getFilters()) > 0;
    }
  }, {
    key: "renderFilter",
    value: function renderFilter(filter) {
      return renderComponent(this.props.itemComponent, {
        key: filter.name + '$$' + filter.value,
        bemBlocks: this.bemBlocks,
        filterId: filter.id,
        labelKey: this.translate(filter.name),
        labelValue: this.translate(filter.value),
        removeFilter: this.removeFilter.bind(this, filter),
        translate: this.translate
      });
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      filter.remove();
      this.searchkit.performSearch();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.hasFilters()) {
        return null;
      }

      return React.createElement("div", {
        className: this.bemBlocks.container()
      }, map(this.getFilters(), this.renderFilter.bind(this)));
    }
  }]);

  return SelectedFilters;
}(SearchkitComponent);
SelectedFilters.propTypes = defaults({}, SearchkitComponent.propTypes);
SelectedFilters.defaultProps = {
  itemComponent: FilterItem
};